import React from "react";
import { Phone, MessageSquare } from "lucide-react";

const CrisisBanner = () => {
    return (
        <div
            className="fixed bottom-0 inset-x-0 z-50 bg-[#B91C1C] text-white border-t-2 border-white/20"
            data-testid="crisis-banner"
        >
            <div className="max-w-7xl mx-auto px-4 lg:px-10 py-2.5 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-xs sm:text-sm">
                <span className="font-display tracking-[0.2em] uppercase">
                    In Crisis? You're not alone.
                </span>
                <div className="flex items-center gap-4 sm:gap-6">
                    <a
                        href="tel:988"
                        className="inline-flex items-center gap-2 hover:underline font-semibold"
                        data-testid="crisis-call-988"
                    >
                        <Phone size={14} />
                        Call or text 988
                    </a>
                    <a
                        href="sms:741741&body=HOME"
                        className="inline-flex items-center gap-2 hover:underline font-semibold"
                        data-testid="crisis-text-741741"
                    >
                        <MessageSquare size={14} />
                        Text HOME to 741741
                    </a>
                </div>
            </div>
        </div>
    );
};

export default CrisisBanner;
